module.exports = __webpack_public_path__ + "img/check0.fd4a0e1c.png";